import { Box } from '@chakra-ui/react';
import {
  Icon,
  IconName,
  IconProps,
  LinkButton,
  LinkButtonProps,
  PayflipBadge
} from '../../atoms';

export function NavLinkButton({
  badge = false,
  children,
  iconName,
  iconProps,
  ...props
}: LinkButtonProps & {
  selected: boolean;
  iconName?: IconName;
  badge?: boolean;
  iconProps?: Omit<IconProps, 'name'>;
}): JSX.Element {
  return (
    <LinkButton
      _hover={{
        backgroundColor: 'palette_gray.0',
        color: props.selected ? 'palette_gray.100' : 'palette_gray.60',
        textDecoration: 'none'
      }}
      _disabled={{
        backgroundColor: 'transparent',
        color: 'palette_gray.40',
        cursor: 'not-allowed',
        textDecoration: 'none'
      }}
      display="flex"
      alignItems="center"
      justifyItems="flex-start"
      textOverflow="ellipsis"
      overflow="hidden"
      fontSize="1rem"
      h="40px"
      w="100%"
      flexShrink={0}
      px="space_unit.x2"
      justifyContent="left"
      transition="color 250ms ease"
      color={props.selected ? 'palette_gray.100' : 'palette_gray.60'}
      backgroundColor="transparent"
      border={0}
      borderRadius={0}
      leftIcon={
        iconName ? (
          <Icon
            w="1.1rem"
            h="1.1rem"
            mr="space_unit.x1"
            name={iconName}
            {...iconProps}
          />
        ) : undefined
      }
      {...props}
    >
      <Box
        w="100%"
        overflow="hidden"
        whiteSpace="nowrap"
        textOverflow="ellipsis"
      >
        {children}
      </Box>
      {badge && <PayflipBadge />}
    </LinkButton>
  );
}
